module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pick":"Pick","unit":"unit","attacker":"attacker","defender":"defender","search-unit":"Search unit"},"ru":{"pick":"Выбор","unit":"юнита","attacker":"атакующего","defender":"защищающегося","search-unit":"Поиск юнита"}}')
  delete Component.options._Ctor
}
